export default [
	{
		text: 'folio',
		value: 'purchase_number',
	},
	{
		text: 'tipo',
		value: 'purchase_type',
		align: 'center',
		component: {
			type: 'chip-label',
			props: {
				small: true,
			}
		},
	},
	{
		text: 'rut',
		value: 'rut',
		//format: 'rut',
	},
	{
		text: 'proveedor',
		value: 'business_name',
	},
	{
		text: 'Vencimiento',
		value: 'date_to_pay',
		format: 'date',
	},
	{
		text: 'pagado',
		value: 'total_paid',
		format: 'currency',
		align: 'right',
		width: '15%',
	},
	{
		text: 'total',
		value: 'total',
		format: 'currency',
		align: 'right',
		width: '15%',
	},
	{
		text: 'monto',
		value: 'amount',
		format: 'currency',
		align: 'right',
		input: {
			type: 'currency-field',
			reverse: true,
		},
		width: '15%',
	},
]